
<div class="page-heading d-flex align-items-center justify-content-between my-3 px-2">
    Rule & Policy <span style="color:red; text-align: right;">{{PageStatus}}</span>
</div>
<form [formGroup]="form" (submit)="submitForm()">
    <ul id="accordion" class="accordion">
        <li *ngFor="let menu of formData; let i = index" [class.active]="menu.active">
            <div class="menu mt-4" (click)="toggle(i)">
                {{ menu.name }}
                <i class="fa fa-chevron-down"></i>
            </div>
            <ul class="submenu " #submenu [style.height.px]="menu.active ? submenu.scrollHeight : 0" >
                <ng-template ngFor let-input [ngForOf]="menu.submenu">
                        <ng-container [ngSwitch]="input.controlType">
                            <ng-template [ngSwitchCase]="'Hidden'">
                                <div style="display:none; ">

                                    <input class="form-control" [formControlName]="input.controlName" type="hidden" [value]="input.selectedValue" />

                                </div>
                            </ng-template>
                            <ng-template [ngSwitchCase]="'TXT'">
                                <br>
                                <div class="form-group col-sm-12 col-md-4 px-2">
                                    <label class="col-sm-4" [for]="input.controlName"> {{input.captionName}}</label>
                                    <input class="col-sm-6 form-control" [formControlName]="input.controlName" type="text" [value]="input.selectedValue" [name]="input.controlName" />
                                    <!-- [maxlength]="input.validators.maxlength" -->
                                    <div class="col-sm-2">&nbsp;</div>
                                </div>
                            </ng-template>
                            <ng-template [ngSwitchCase]="'NTXT'">
                                <br>
                                <div class="form-group col-sm-12 col-md-4 px-2">
                                    <label class="col-sm-4" [for]="input.controlName"> {{input.captionName}}</label>
                                    <input class="col-sm-6 form-control" [formControlName]="input.controlName" type="number" [value]="input.selectedValue" [name]="input.controlName" />
                                    <div class="col-sm-2">&nbsp;</div>
                                </div>
                            </ng-template>
                            <ng-template [ngSwitchCase]="'MTXT'">
                                <br>
                                <div class="form-group col-sm-12 col-md-4 px-2">
                                    <label class="col-sm-4" [for]="input.controlName"> {{input.captionName}}</label>
                                    <textarea class="col-sm-6 form-control" [formControlName]="input.controlName" [value]="input.selectedValue" [name]="input.controlName"></textarea>
                                    <div class="col-sm-2">&nbsp;</div>
                                </div>
                            </ng-template>

                            <ng-template [ngSwitchCase]="'HLP'">
                                <div class="form-group col-sm-12 col-md-4 px-2">
                                    <label  [for]="input.controlName"> {{input.captionName}}</label>
                                    <div >
                                        <ng-select [items]="input.Options" [clearable]="false" [multiple]="false" [formControlName]="input.controlName" bindLabel="optionName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="value" [(ngModel)]="input.selectedValue">
                                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                                {{item.optionName}}
                                            </ng-template>
                                        </ng-select>
                                    </div>
                                </div>
                            </ng-template>

                            <ng-template [ngSwitchCase]="'MHLP'">
                                <div class="form-group col-sm-12 col-md-4 px-2">
                                    <label  [for]="input.controlName"> {{input.captionName}}</label>
                                    <div >
                                        <ng-select [items]="input.Options" [clearable]="false" [multiple]="true" [formControlName]="input.controlName" bindLabel="optionName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="value" [(ngModel)]="input.selectedValue3">
                                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                                {{item.optionName}}
                                            </ng-template>
                                        </ng-select>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template [ngSwitchCase]="'HLPTXT'">
                                <div class="form-group col-sm-12 col-md-4 px-2">
                                    <label > {{input.captionName}}</label>
                                    <input class="col-sm-3 form-control" style="margin-left:5%;" [formControlName]="input.controlName" type="text" [value]="input.selectedValue" [name]="input.controlName" [required]="input.validators.required" [minlength]="input.validators.minlength" [maxlength]="input.validators.maxlength"
                                    />
                                    <input class="col-sm-3 form-control" style="margin-left:7%;" [formControlName]="input.controlName2" type="text" [value]="input.selectedValue2" [name]="input.controlName2" [required]="input.validators.required" [minlength]="input.validators.minlength"
                                        [maxlength]="input.validators.maxlength" />
                                </div>

                            </ng-template>
                            <ng-template [ngSwitchCase]="'DTP2'">
                                <div class="form-group col-sm-12 col-md-4 px-2">
                                    <label class=" col-sm-4" style="padding-top: 15px;"> {{input.captionName}}</label>
                                    <mat-form-field class="fullwidth col-sm-3">
                                        <input matInput [readonly]="!editable" [min]="minDate" [formControlName]="input.controlName" [max]="maxDate" [matDatepicker]="picker" placeholder="Choose a date">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field class="fullwidth col-sm-3">
                                        <input matInput [readonly]="!editable" [min]="minDate" [formControlName]="input.controlName2" [max]="maxDate" [matDatepicker]="picker1" placeholder="Choose a date">
                                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                        <mat-datepicker #picker1></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </ng-template>

                            <ng-template [ngSwitchCase]="'CHK'">
                                <br>
                                <div class="form-group col-sm-12 col-md-4 px-2">
                                    <label > {{input.controlType}}</label>
                                    <input class="col-sm-1 " type="checkbox" [checked]="input.selectedValue" [formControlName]="input.controlName" />
                                </div>
                            </ng-template>
                        </ng-container>
                </ng-template>
            </ul>
        </li>
    </ul>
    <div class="d-flex align-items-center justify-content-center mt-3">
        <button class="btn btn-primary submit-btn small"
                type="submit">
            Submit
        </button>
    </div>
</form>
